import { render, staticRenderFns } from "./collectupload.vue?vue&type=template&id=8c772850&scoped=true&"
import script from "./collectupload.vue?vue&type=script&lang=ts&"
export * from "./collectupload.vue?vue&type=script&lang=ts&"
import style0 from "./collectupload.vue?vue&type=style&index=0&id=8c772850&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c772850",
  null
  
)

export default component.exports